import {createActionCreators, createReducerFunction, ImmerReducer} from 'immer-reducer';

export type dimensions = {
    height: number;
    width: number;
};
export type State = {
    dimensions: dimensions;
    graphWidth: number;
    graphHeight: number;
};
export const initialState: State = {
    dimensions: {
        height: 0,
        width: 0
    },
    graphWidth: 0,
    graphHeight: 0
};

export class ChartState extends ImmerReducer<State>{
    
    SetGraphWidth(width: number){
        this.draftState.graphWidth = width
    }

    SetGraphHeight(height: number){
        this.draftState.graphHeight = height
    }
}

export const ChartAction = createActionCreators(ChartState)
export const chartreducerFunction = createReducerFunction(ChartState,initialState)

